import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from '../shared/_helpers/authentication.service';
import { Router } from '@angular/router';
import { LoadingService } from '../shared/loading-spinner/loading.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

  @ViewChild('loginForm') loginForm: NgForm;
  public authError = false;

  constructor(private _authenticationService: AuthenticationService, private _router: Router, private _loadingService: LoadingService) {
    if (this._authenticationService.currentUserDataValue) {
      if (this._authenticationService.currentUserDataValue.token) {
        if (this._authenticationService.currentUserDataValue.accountType === 1) {
          this._router.navigate(['user', 'counter', this._authenticationService.currentUserDataValue.orgId]);
        } else {
          this._router.navigate(['']);
        }
      }
    }
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.authError = false;
    if (this.loginForm.valid) {
      this._loadingService.setHttpProgressStatus(true);
      this._authenticationService.loginPost(this.loginForm.value.email.trim(), this.loginForm.value.password.trim()).subscribe(() => {
        this._authenticationService.userData.subscribe(userData => {
          console.log(userData);
          if (userData) {
            switch (userData.accountType) {
              case 1:
                this._router.navigate(['user', 'counter', userData.orgId]);
                break;
              case 5:
              case 6:
              case 7:
                this._router.navigate(['vss']);
                break;
              default:
                this._router.navigate(['']);
                break;
            }
            this._loadingService.setHttpProgressStatus(false);
          }
        });
      }, responseError => {
        console.log(responseError);
        this.authError = true;
      });
    }
  }

}
